import { EChart } from '@kbox-labs/react-echarts';

export const DoughnutChart = ({
  totalTask,
  taskProgress,
}: {
  totalTask: number;
  taskProgress: {
    none: number;
    pending: number;
    ready: number;
    progress: number;
    completed: number;
    fail: number;
  };
}) => {
  return (
    <EChart
      style={{ width: '316px', height: '128px' }}
      grid={{
        left: '0px',
        top: '0px',
        bottom: '0px',
        right: '0px',
        containLabel: true,
      }}
      legend={{
        orient: 'vertical',
        right: '0px',
        top: 'center',
        itemWidth: 8,
        itemHeight: 8,
        itemStyle: {
          borderRadius: '9999px',
        },
        formatter: name => {
          const data = [
            {
              name: 'Not started',
              value:
                taskProgress.ready + taskProgress.pending + taskProgress.none,
            },
            {
              name: 'In progress',
              value: taskProgress.progress,
            },
            {
              name: 'Completed',
              value: taskProgress.completed,
            },
          ].find(item => item.name === name);

          const count = data?.value || 0;
          const percentage =
            totalTask > 0 ? Math.round((count / totalTask) * 100) : 0;

          return `{name|${name}} {count|${count
            .toString()
            .padStart(3, '0')}} {divider||} {percent|${percentage
            .toString()
            .padStart(2, '0')}%}`;
        },

        textStyle: {
          rich: {
            name: {
              fontSize: 14,
              color: '#333',
              fontWeight: 400,
            },
            count: {
              fontSize: 14,
              color: '#333',
              fontWeight: 400,
            },
            divider: {
              color: '#D3D3D3',
              padding: [0, 4],
            },
            percent: {
              fontSize: 14,
              color: '#333',
              fontWeight: 400,
            },
          },
        },
      }}
      series={[
        {
          radius: ['65%', '90%'],
          center: ['20%', '50%'],
          labelLine: {
            show: false,
          },
          label: {
            show: true,
            position: 'center',
            formatter: () => {
              const completedPercentage =
                totalTask > 0
                  ? Math.round((taskProgress.completed / totalTask) * 100)
                  : 0;
              return `{title|Completed}\n{percentage|${completedPercentage}%}`;
            },
            fontSize: 14,
            fontWeight: 'bold',
            color: '#2A58F6',
            rich: {
              title: {
                fontSize: 10,
                fontWeight: 'normal',
                color: '#2A58F6',
              },
              percentage: {
                fontSize: 14,
                fontWeight: 'bold',
                color: '#2A58F6',
              },
            },
          },
          type: 'pie',
          data: [
            {
              value:
                taskProgress.ready + taskProgress.pending + taskProgress.none,
              name: 'Not started',
              itemStyle: {
                color: '#B6C8DD',
              },
            },
            {
              value: taskProgress.progress,
              name: 'In progress',
              itemStyle: {
                color: '#37C982',
              },
            },
            {
              value: taskProgress.completed,
              name: 'Completed',
              itemStyle: {
                color: '#2A58F6',
              },
            },
          ],
        },
      ]}
    />
  );
};
